class EqualHeights {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-equal-heights="scope"]',
			item: '[data-equal-heights="item"]',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.each((index, scope) => {
			new ResizeObserver((entries, observer) => {
				let scope = Array.from(entries)[0].target;
				let $scope = $(scope);
				this.removeHeight($scope)
				this.setHeight($scope)
			}).observe(scope);
		});
	}

	removeHeight($scope) {
		$scope.find(this.config.item).css('height', '');
	}

	setHeight($scope) {
		this.timeout ? clearTimeout(this.timeout) : null;
		this.timeout = setTimeout(() => {
			let $items = $scope.find(this.config.item);
			let height = 0;

			$items.each((index, item) => {
				let $item = $(item);
				if ($item.outerHeight() > height) {
					height = $item.outerHeight();
				}
			});

			$items.css('height', height + 'px');
		}, 300);
	}
}

export default EqualHeights;